import { FC, SVGProps } from 'react';

const Trash: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.6154 7.33333C20.3801 7.33333 21 6.73638 21 6V4.66667C21 3.93029 20.3801 3.33333 19.6154 3.33333H14.7692C14.7692 2.59695 14.1493 2 13.3846 2H10.6154C9.85068 2 9.23077 2.59695 9.23077 3.33333H4.38462C3.61991 3.33333 3 3.93029 3 4.66667V6C3 6.73638 3.61991 7.33333 4.38462 7.33333H5.07692V19.3333C5.07692 20.8061 6.31675 22 7.84615 22H16.1538C17.6832 22 18.9231 20.8061 18.9231 19.3333V7.33333H19.6154ZM6.46154 7.412L6.62492 7.33333H17.3751L17.5385 7.412V19.3333C17.5385 20.0697 16.9185 20.6667 16.1538 20.6667H7.84615C7.08145 20.6667 6.46154 20.0697 6.46154 19.3333V7.412ZM4.38462 6V4.66667H19.6154V6H4.38462ZM9.23077 10C9.23077 9.63181 8.92081 9.33333 8.53846 9.33333C8.15611 9.33333 7.84615 9.63181 7.84615 10V18C7.84615 18.3682 8.15611 18.6667 8.53846 18.6667C8.92081 18.6667 9.23077 18.3682 9.23077 18V10ZM12.6923 10C12.6923 9.63181 12.3824 9.33333 12 9.33333C11.6176 9.33333 11.3077 9.63181 11.3077 10V18C11.3077 18.3682 11.6176 18.6667 12 18.6667C12.3824 18.6667 12.6923 18.3682 12.6923 18V10ZM16.1538 10C16.1538 9.63181 15.8439 9.33333 15.4615 9.33333C15.0792 9.33333 14.7692 9.63181 14.7692 10V18C14.7692 18.3682 15.0792 18.6667 15.4615 18.6667C15.8439 18.6667 16.1538 18.3682 16.1538 18V10Z"
      fill="currentColor"
    />
  </svg>
);

export default Trash;
